import {inject, ref} from 'vue';
import {defineStore, storeToRefs} from 'pinia';
import {RegisteredRepositories} from '~/config/application.services';
import type {AdminEventRequest} from '~/types/api-raw-types';
import type {AdminEvents} from '~/types/domain/AdminEvents';
import type {Profile} from '~/types/domain/Profile';
import type {ProfileAdmin} from '~/types/domain/ProfileAdmin';
import {useProfileStore} from './profileStore';

export const useProfileAdminStore = defineStore('profile-admin', () => {
    const _profileAdminRepository = inject(RegisteredRepositories.injectionKeys.profileAdmin)!;
    const _profileRepository = inject(RegisteredRepositories.injectionKeys.profile)!;
    const {profile} = storeToRefs(useProfileStore());

    // Exposed refs a-z
    const adminEvents = ref<AdminEvents>();
    const profileAdmin = ref<ProfileAdmin>();

    // Exposed functions a-z
    function addAdminEvent(adminEvent: AdminEventRequest, profile: Profile) {
        return _profileAdminRepository.addAdminEvent(adminEvent, profile);
    }
    async function getAdminEvents() {
        adminEvents.value = await _profileAdminRepository.fetchAdminEvents(profile.value!);
    }

    async function getProfileAdmin() {
        profileAdmin.value = await _profileRepository.fetchProfileAdmin(profile.value!);
    }

    return {
        // refs a-z
        adminEvents,
        profileAdmin,
        // functions a-z
        addAdminEvent,
        getAdminEvents,
        getProfileAdmin,
    };
});
